<fieldset>
  <legend [ngClass]="{'is-visually-hidden': labelHidden, 'is-required': required}">
    {{ labelTitle }} {{required ? '(' + ('forms.mandatory' | translate) + ')' : ''}}
  </legend>
  <ul class="c__checkbox-group" sdUpDown>
    @for (item of items; track item?.libelle) {
      <li class="c__checkbox {{customListClass}}" (keydown.enter)="clickCheckbox(item)" (keydown.space)="clickCheckbox(item)">
        <sd-form checkbox
          [brand]="brand"
          [labelTitle]="item.libelle + (item.count !== undefined ? ' (' + item.count + ')' : '')"
          [nameField]="nameField"
          [(checked)]="item.checked"
          [libelleTemplate]="libelleTemplate"
          (checkedChange)="updateCheckbox(item)"
          [required]="required"
          [disabled]="item.disabled"
        >
          <ng-template #libelleTemplate>
            @if (item?.templateData) {
              <ng-container *ngTemplateOutlet="groupLibelleTemplate; context: { item: item?.templateData, index: $index }" />
            }
          </ng-template>
        </sd-form>
      </li>
    }
  </ul>
  <ng-content select="[message]" />
</fieldset>
